module.exports = __webpack_public_path__ + "assets/certificate_pdf/Prof.VocabularyQuotient Credential-ICT-Expert-Tier Five_GLAD_20141017.61ee16dc.pdf";